import type { PullRequestDetail } from "@afar-research/contracts";
import {
  usePullRequestSurfaceStore,
  type PullRequestSurfaceDescriptor,
} from "../pullRequestSurfaceStore";
import { useEnvironments } from "../state/environments";
import { pullRequestEnvironment } from "../state/pullRequests";
import { appAtomRegistry } from "../rpc/atomRegistry";
import { invalidatePullRequest } from "../pullRequestInvalidation";
import { PullRequestEditor } from "./PullRequestEditor";

export function PullRequestEdit({
  descriptor,
  detail,
  active,
}: {
  readonly descriptor: PullRequestSurfaceDescriptor;
  readonly detail: PullRequestDetail;
  readonly active: boolean;
}) {
  const session = usePullRequestSurfaceStore((state) => state.edits.get(descriptor.id));
  const { environments } = useEnvironments();
  const environment = environments.find((item) => item.environmentId === descriptor.environmentId);
  if (!session || environment?.serverConfig?.environment.capabilities.pullRequestEdit !== "edit-v1")
    return null;
  const canEdit =
    detail.capabilities.edit?.changeRequest && detail.viewerPermissions.editChangeRequest;
  if (
    !canEdit &&
    (session.getState().command === null || session.getState().result?.status === "settled")
  )
    return null;
  return (
    <PullRequestEditor
      session={session}
      detail={detail}
      environmentId={descriptor.environmentId}
      enabled={
        active &&
        environment.connection.phase === "ready" &&
        (Boolean(canEdit) || session.getState().command !== null)
      }
      execute={async (input) => {
        const result = await pullRequestEnvironment.edit.run(appAtomRegistry, {
          environmentId: descriptor.environmentId,
          input,
        });
        invalidatePullRequest({ ...input, environmentId: descriptor.environmentId });
        if (result._tag === "Failure") throw new Error("The command response was lost.");
        return result.value;
      }}
    />
  );
}
